export enum loadStatus {
    notLoaded,
    load,
    loaded,
    errorServer,
}
